// extracted by mini-css-extract-plugin
module.exports = {"btn":"button_btn__0p4DC","wider":"button_wider__QlG8J","wider-center":"button_wider-center__6OtDO","eventButton":"button_eventButton__uoY19","disabled":"button_disabled__fZNFm"};